
import Card from '../../../components/base/Card';

interface Booking {
  id: string;
  service: string;
  doctor: string;
  date: string;
  time: string;
  status: 'confirmed' | 'pending' | 'completed';
  center: string;
}

const recentBookings: Booking[] = [
  {
    id: '1',
    service: 'استشارة طبية',
    doctor: 'د. أحمد محمد',
    date: '2024-01-15',
    time: '10:00 ص',
    status: 'confirmed',
    center: 'مستشفى الملك فهد'
  },
  {
    id: '2',
    service: 'تحاليل مختبرية',
    doctor: 'مختبر التشخيص',
    date: '2024-01-12',
    time: '08:30 ص',
    status: 'completed',
    center: 'مختبر العلا الطبي'
  }
];

const getStatusColor = (status: string) => {
  switch (status) {
    case 'confirmed':
      return { bg: 'bg-[#34C759]/10', text: 'text-[#34C759]', label: 'مؤكد' };
    case 'pending':
      return { bg: 'bg-[#F9A826]/10', text: 'text-[#F9A826]', label: 'قيد المراجعة' };
    case 'completed':
      return { bg: 'bg-[#007AFF]/10', text: 'text-[#007AFF]', label: 'مكتمل' };
    default:
      return { bg: 'bg-gray-100', text: 'text-gray-600', label: 'غير محدد' };
  }
};

export default function RecentBookings() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-[#333333]">حجوزاتي الأخيرة</h2>
        <button className="text-[#007AFF] text-sm font-medium">عرض الكل</button>
      </div>
      
      <div className="space-y-3">
        {recentBookings.map((booking) => {
          const statusStyle = getStatusColor(booking.status);
          return (
            <Card key={booking.id} padding="md">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-bold text-[#333333] text-sm">{booking.service}</h3>
                <span className={`${statusStyle.bg} ${statusStyle.text} px-2 py-1 rounded-lg text-xs font-medium`}>
                  {statusStyle.label}
                </span>
              </div>
              
              <div className="space-y-2 text-xs text-[#7A7A7A]">
                <div className="flex items-center gap-2">
                  <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                  <span>{booking.doctor}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-hospital-line w-4 h-4 flex items-center justify-center"></i>
                  <span>{booking.center}</span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                    <span>{booking.date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                    <span>{booking.time}</span>
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
